import { useEffect } from "react";

export function initializeCalculationFilters(translate) {
  let initialFilters = [
    {
      id: "dataBasis",
      label: translate("benchmarking.calculations-page.filters.dataBasis"),
      type: "dropDown",
      items: [],
      value: null,
    },
    {
      id: "surveyYears",
      label: translate("benchmarking.evaluations.salary.filters.year"),
      type: "dropDown",
      items: [],
      value: null,
    },
    {
      id: "functionId",
      label: translate("benchmarking.evaluations.salary.filters.function"),
      type: "dropDown",
      items: [],
      value: null,
    },
    { id: "levelId", label: translate("benchmarking.data-table.header-row.average"), type: "dropDown", items: [], value: null },
  ];
  return { filters: initialFilters, newest: true, isInitialLoad: true, allAvailableFilters: {} };
}

export function useStateReinitialize(setter, initializer, translate) {
  useEffect(() => {
    setter(initializer(translate));
  }, [translate]);
}
